import React from 'react'

const CreateSendDocs = () => {
    return (
        <div>
            CreateSendDocs
        </div>
    )
}

export default CreateSendDocs;
